var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvertedComma1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24066 19.3419C4.37426 8.13521 12.1047 0 19.619 0C20.2226 0 20.8256 0.0525347 21.413 0.156411C21.7461 0.214916 22.0375 0.41073 22.2177 0.694898C22.3974 0.980857 22.4482 1.32831 22.3568 1.65307L20.81 7.18599C20.6608 7.72029 20.1456 8.08147 19.6101 8.057L19.4871 8.05461C16.7004 8.05461 11.6074 12.2312 9.0111 21.5138C8.90841 21.8821 8.81111 22.2588 8.71738 22.6517C11.6319 21.2093 15.1088 20.8756 18.2573 21.7526C25.3603 23.74 29.5213 31.1343 27.5357 38.2361C25.9263 43.9905 20.6327 48.0107 14.6628 48.0107C13.4467 48.0107 12.2325 47.8429 11.0534 47.5128C6.36941 46.2036 2.84776 42.3148 1.13678 36.5651C-0.407635 31.3779 -0.368834 25.1005 1.24066 19.3419Z",
    fill: "url(#paint0_linear_504_71)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5898 0C51.1921 0 51.7957 0.0513408 52.3825 0.155217C52.715 0.212529 53.007 0.409536 53.1867 0.693704C53.3664 0.979663 53.4171 1.32711 53.3264 1.65188L51.779 7.18479C51.6297 7.7191 51.1241 8.08028 50.579 8.0558L50.4572 8.05341C47.6705 8.05341 42.5769 12.23 39.9806 21.5126C39.8773 21.8833 39.78 22.26 39.6869 22.6505C42.6026 21.2081 46.0783 20.8744 49.2268 21.7514C56.3286 23.7388 60.4909 31.1331 58.5041 38.2349C56.8946 43.9893 51.6011 48.0095 45.6311 48.0095C44.4151 48.0095 43.2008 47.8417 42.0211 47.5116C37.3377 46.2024 33.8161 42.3136 32.1045 36.5639C30.5607 31.3767 30.5989 25.0987 32.209 19.3395C35.3444 8.13401 43.0736 0 50.5898 0Z",
    fill: "url(#paint1_linear_504_71)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_71",
    x1: 14.0183,
    y1: 0,
    x2: 14.0183,
    y2: 48.0107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0750B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_71",
    x1: 44.9867,
    y1: 0,
    x2: 44.9867,
    y2: 48.0095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0750B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedComma1);
export default __webpack_public_path__ + "static/media/invertedComma1.74c2bb9d574a0d4db745d8be1e5b895b.svg";
export { ForwardRef as ReactComponent };